/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerCreateMutationRequest, TeamsControllerCreateMutationResponse, TeamsControllerCreate400, TeamsControllerCreate401, TeamsControllerCreate403 } from "../../models/teamsController/TeamsControllerCreate";

function getTeamsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/teams` as const }  
  return res
}

/**
 * @summary Create a new team
 * {@link /api/v1/teams}
 */
export async function teamsControllerCreate(data?: TeamsControllerCreateMutationRequest, config: Partial<RequestConfig<TeamsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TeamsControllerCreateMutationResponse, ResponseErrorConfig<TeamsControllerCreate400 | TeamsControllerCreate401 | TeamsControllerCreate403>, TeamsControllerCreateMutationRequest>({ method : "POST", url : getTeamsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}